var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFmhExternalLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66536 30.6667C1.92898 30.6667 1.33203 30.0698 1.33203 29.3334L1.33203 2.66675C1.33203 1.93037 1.92898 1.33342 2.66536 1.33342L14.6654 1.33342L27.9987 1.33341L27.9987 17.3334L30.6654 17.3334L30.6654 29.3334C30.6654 30.0698 30.0684 30.6667 29.332 30.6667L2.66536 30.6667ZM3.9987 28.0001L27.9987 28.0001L27.9987 20.0001L27.9987 1.33341L14.6654 1.33342L14.6654 4.00008L3.9987 4.00008L3.9987 28.0001ZM15.0559 16.9429C14.5352 16.4222 14.5352 15.578 15.0559 15.0573L26.1131 4.00008L19.9987 4.00008C19.2623 4.00008 18.6654 3.40313 18.6654 2.66675C18.6654 1.93037 19.2623 1.33342 19.9987 1.33342L29.332 1.33341C30.0684 1.33341 30.6654 1.93037 30.6654 2.66675L30.6654 12.0001C30.6654 12.7365 30.0684 13.3334 29.332 13.3334C28.5956 13.3334 27.9987 12.7365 27.9987 12.0001L27.9987 5.8857L16.9415 16.9429C16.4208 17.4636 15.5766 17.4636 15.0559 16.9429Z",
    fill: "#0088E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFmhExternalLink);
export default __webpack_public_path__ + "static/media/fmh-external-link.b4334fd7b1adb3937c74f98ef58213dd.svg";
export { ForwardRef as ReactComponent };